<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <a-button type="default" slot="extra" @click="handleBack">返回</a-button>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">

                <a-form-model-item ref="kaenv" label="KA环境编码" prop="kaenv">
                    <span>{{record.kadesc + ' - ' + record.kaenv}}</span>
                </a-form-model-item>

                <a-form-model-item ref="syscode" label="系统编码" prop="syscode">
                    <sysSelecter :kaenv="record.kaenv" ref="sysSelecter" v-if="is_vue_task"
                        @handleSelect="handleSysSelect"></sysSelecter>
                    <span v-else>{{record.syscode}}</span>
                </a-form-model-item>

                <a-form-model-item label="分支模式">
                    <a-radio-group v-model="branch_type" @change="handleBranchTypeChange">
                        <a-radio value="1">
                            代码主干
                        </a-radio>
                        <a-radio value="2">
                            选择分支
                        </a-radio>
                        <a-radio value="3">
                            完整路径
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item v-if="branch_type == '1'" ref="branch" label="代码分支" prop="branch">
                    <span>{{record.branch}}</span>
                </a-form-model-item>

                <a-form-model-item v-show="branch_type == 2" ref="branch" label="代码分支" prop="branch">
                    <BranchAutoComplete v-show="is_vue_task" ref="branchAss" @onBranchChange="handleBranchChange">
                    </BranchAutoComplete>
                    <span v-if="!is_vue_task">{{record.branch}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="branch_type == 3" ref="branch" label="代码分支" prop="branch">
                    <a-input v-if="is_vue_task" v-model="record.branch"></a-input>
                    <span v-else>{{record.branch}}</span>
                </a-form-model-item>
                

                <a-form-model-item label="cpu" ref="cpu" prop="cpu">
                    <a-input-number v-if="is_vue_task" style="width:200px;" v-model="record.cpu" placeholder="cpu数最大20"
                        :min="0" :max="20">
                    </a-input-number>
                    <span v-else>{{record.cpu}}</span>

                </a-form-model-item>

                <a-form-model-item label="memory" ref="memory" prop="memory">
                    <a-input-number v-if="is_vue_task" style="width:200px;" v-model="record.memory"
                        placeholder="内存大小，单位M,最大99999" :min="1" :max="99999">
                    </a-input-number>
                    <span v-else>{{record.memory}}</span>

                </a-form-model-item>

                <a-form-model-item label="副本数量" ref="replics" prop="replics">
                    <a-input v-if="is_vue_task" v-model="record.replics"></a-input>
                    <span v-else>{{record.replics}}</span>

                </a-form-model-item>

                <a-form-model-item label="Java启动参数" ref="javaopts" prop="javaopts">
                    <a-input v-if="is_vue_task" v-model="record.javaopts"></a-input>
                    <span v-else>{{record.javaopts}}</span>

                </a-form-model-item>

                <a-form-model-item ref="appconfig" label="应用配置" prop="appconfig">
                    <!-- <a-button type="primary" v-if="record.syscode" @click="getAppconfig()">获取默认配置</a-button> -->
                    <JsonXmlEditor :title="'应用配置：'" :language="'xml'" v-model="record.appconfig"></JsonXmlEditor>
                </a-form-model-item>

                <a-form-model-item ref="paramjson" label="额外参数" prop="paramjson">
                    <JsonXmlEditor :title="'JSON参数：'" v-model="record.paramjson"></JsonXmlEditor>
                </a-form-model-item>


                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import JsonXmlEditor from '../../../components/JsonXmlEditor'
import sysSelecter from '../com/sysSelecter.vue'
import BranchAutoComplete from '@/components/BranchAutoComplete'

const m_title = {
    'newbindsys':'新增关联系统',
    'editbindsys':'编辑关联系统',
    'detailbindsys':'关联系统详情'
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            rules: {
                syscode: [
                    { required: true, message: ' 请选择关联系统', trigger: 'blur' },
                ],
                branch:[
                    { required: true, message: ' 请选择代码分支', trigger: 'blur' },
                ],
                configname:[
                    { required: true, message: '请填写配置名称', trigger: 'blur' },
                ],
                appconfig : [
                    { required: false, message: '请填写应用配置', trigger: 'blur' },
                ],
                cpu : [
                    { required: false, message: '请配置cpu', trigger: 'blur' },
                ],
                memory : [
                    { required: false, message: '请配置内存', trigger: 'blur' },
                ],
                replics : [
                    { required: false, message: '请填写副本数量', trigger: 'blur' },
                ],
                javaopts : [
                    { required: false, message: '请填写java启动参数', trigger: 'blur' },
                ],
       
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            branch_type:'1',
            record:{
                kadesc:'',
                apptype:'',
                kaenv:'',
                syscode:'',//关联的Jenkins基础配置的系统编码
                paramjson:'',//配置json
                branch:'',//分支
                appconfig:'',//应用配置，Java应用必填
                cpu:'',//cpu数量：Java应用必填  默认值 1，最大值可设置为20
                memory:'',//内存大小：Java应用必填  默认值 1500，最大值可设置5位数
                replics:'',//副本数量（Java应用必填）：1、单实例项目，副本数量为单个数字，例如：1  2、多实例项目，副本数量为多个数字，空格分开，例如 ：1 1
                javaopts:''//Java启动参数  默认值   -Xms1000m -Xmx1500m -Xmn750m -Xss256k
            },
        };
    },
    computed: {

    },
    components:{
        JsonXmlEditor,
        sysSelecter,
        BranchAutoComplete
    },
    methods: {

        handleBranchTypeChange(){
            let resultBranch  = '';
            if(this.branch_type == 1){
                resultBranch = 'trunk'
            }
            else if(this.branch_type == 2){
                resultBranch = ''
            }
            else{
                resultBranch = ''
            }
            this.record.branch =resultBranch
        },
        handleBack(){
            this.$router.push({
                path:'bindsys',
                query:{
                    kaenv:this.record.kaenv
                }
            })
        },
        handleSysSelect(sys){
            this.record.syscode = sys.syscode;
            this.record.apptype = sys.apptype;
            //改变规则
            this.rules.appconfig[0].required = sys.apptype == 'Java'
            this.rules.cpu[0].required = sys.apptype == 'Java'
            this.rules.memory[0].required = sys.apptype == 'Java'
            this.rules.replics[0].required = sys.apptype == 'Java'
            this.rules.javaopts[0].required = sys.apptype == 'Java'
            let record = this.record;
            if(sys.apptype == 'Java'){
                record.cpu = record.cpu ? record.cpu : 0.2;
                record.memory = record.memory ? record.memory : 1500;
                record.javaopts = record.javaopts ? record.javaopts : '-Xms1000m -Xmx1500m -Xmn750m -Xss256k';
                if(this.is_new){
                    this.getDefaultConfig()
                }
            }
     

        },
        handleBranchChange(value){
            this.record.branch = value
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'editbindsys'){
                        that.$store
                            .dispatch({
                                type: "kamanager/updaterelatesys",
                                params: {
                                    ...that.record,
                                    operateuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'newbindsys'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "kamanager/addrelateSys",
                                params: {
                                    ...that.record,
                                    createuser:this.G.getCurrentUser().username,
                                    urlparams: false,
                                }
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.branch_type = '1'
            this.record = {
                kadesc:'',
                apptype:'',
                kaenv:'',
                syscode:'',//关联的Jenkins基础配置的系统编码
                paramjson:'',//配置json
                branch:'trunk',//分支
                appconfig:'',//应用配置，Java应用必填
                cpu:'',//cpu数量：Java应用必填  默认值 1，最大值可设置为20
                memory:'',//内存大小：Java应用必填  默认值 1500，最大值可设置5位数
                replics:'',//副本数量（Java应用必填）：1、单实例项目，副本数量为单个数字，例如：1  2、多实例项目，副本数量为多个数字，空格分开，例如 ：1 1
                javaopts:''//Java启动参数  默认值   -Xms1000m -Xmx1500m -Xmn750m -Xss256k
            }
        },

        getDetail(query){
            let that = this;
            that.$store.dispatch({
                type: "kamanager/detailrelatesys",
                params: {
                    syscode:query.syscode,
                    kaenv:query.kaenv,
                    urlparams:false

                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.$refs.branchAss.setInputVal(result.branch);
                    that.$refs.sysSelecter.init(result.syscode)
                    that.record = {
                        ...result
                    }
                    that.record.kadesc = query.kadesc
                }
            });
        },
        getDefaultConfig(){
            let that = this;
            that.$store.dispatch({
                type: "kamanager/queryJenkins",
                params: {
                    syscode:that.record.syscode,
                    kaenv:that.record.kaenv,
                    urlparams:false
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record.appconfig = result.appconfig
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "newbindsys";
        if (!this.is_new) {
            this.getDetail(query)
        }
        else{
            this.resetForm();
            //初始化值
            this.record.kaenv = query.kaenv;
            this.record.kadesc = query.kadesc;

        }
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
